import { ISpinnerProps, Layer, Overlay, Spinner, SpinnerSize, Stack, useTheme } from "@fluentui/react";
import React from "react";

import { isDarkModeTheme } from "../utils/TypescriptUtils";

const ModalSpinner: React.FC = () => {
  const theme = useTheme();

  const styles: ISpinnerProps["styles"] = {
    label: !isDarkModeTheme(theme) && {
      color: "#0072c9",
    },
  };

  return (
    <Layer>
      <Overlay>
        <Stack verticalAlign="center" horizontalAlign="center" style={{ height: "100%" }}>
          <Spinner
            aria-live="assertive"
            styles={styles}
            label="Loading..."
            ariaLabel="Loading..."
            size={SpinnerSize.large}
          />
        </Stack>
      </Overlay>
    </Layer>
  );
};

export default ModalSpinner;
